import React from "react";
import { CookiePage } from "@v2/components/policies/cookie";

export default function CookiePolicy() {
    return <CookiePage />;
}
